import { getSapStoreId } from '../../../../lib/auth'
import {
  ORDER_DETAILS_API_URL,
  ORDER_DETAILS_PAGE_SIZE,
} from '../constants/pagination'

const ALLOWED_QUERY_KEYS = [
  'orderId',
  'referenceNumber',
  'childOrderId',
  'status',
  'source',
  'storeId',
  'sapStoreId',
  'placedOn',
  'preferredDate',
  'slotStartTime',
  'slotEndTime',
  'picklistId',
  'packlistZone',
  'packlistStatus',
  'page',
  'pageSize',
]

export { ORDER_DETAILS_API_URL, ORDER_DETAILS_PAGE_SIZE }

// Shared implementation lives in lib/auth alongside getStores.
export const mapStoreIdToSapStoreId = (storeId) => getSapStoreId(storeId)

/**
 * Maps list/filter form values (+ store scope) to SearchOrderDetails query params.
 * Platform storeId is sent as-is so the API filters on order_details.store_id.
 * Drops legacy-only fields (campaignId, type, productType).
 */
export const buildQueryParams = (raw = {}) => {
  const params = { ...raw }

  if (params.slot) {
    try {
      const slotDetails = JSON.parse(params.slot)
      if (slotDetails.startTime) {
        params.slotStartTime = slotDetails.startTime
      }
      if (slotDetails.endTime) {
        params.slotEndTime = slotDetails.endTime
      }
    } catch (e) {
      // leave slot times unset if slot payload is invalid
    }
    delete params.slot
  }

  // never send slot type / order type to picking orderDetails
  delete params.type

  // Prefer platform storeId for store-scoped listing; drop mapped sapStoreId
  // so we do not AND-filter on both when the UI only selected a store.
  if (params.storeId !== undefined && params.storeId !== null && params.storeId !== '') {
    delete params.sapStoreId
  } else {
    delete params.storeId
  }

  delete params.campaignId
  delete params.productType
  delete params.customer
  delete params.customerId
  delete params.filters
  delete params.fields

  if (!params.pageSize) {
    params.pageSize = ORDER_DETAILS_PAGE_SIZE
  }

  return ALLOWED_QUERY_KEYS.reduce((acc, key) => {
    const value = params[key]
    if (value === 0 || value) {
      acc[key] = value
    }
    return acc
  }, {})
}

export const normalizeRows = (response) => {
  if (!response) {
    return []
  }
  return response.orderDetails || []
}
